import React from 'react'
import { Button, useWalletModal } from '../../uikit'
import useAuth from 'hooks/useAuth'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const MojitoButton = styled(Button)`
  border-radius: 22px;
  height: 42x;
  font-size: 16px;
  color: #fff;
  background: linear-gradient(91.72deg, #14d89d 1.03%, #0ac4dd 102.03%);
`

const UnlockButton: React.FC<any> = (props) => {
  const { t } = useTranslation()
  const { login, logout } = useAuth()
  const { onPresentConnectModal } = useWalletModal(login, logout)

  return (
    <MojitoButton onClick={onPresentConnectModal} {...props}>
      {t('COMPONENTS_157')}
    </MojitoButton>
  )
}

export default UnlockButton
